module.exports = __webpack_public_path__ + "img/图片8.6d167a58.png";